<template>
  <CCardBody class="pb-4">
    <ul v-if="hasBilling" class="d-flex justify-content-between flex-wrap">
      <li class="w-50" v-for="(value, name) in form" :key="name">
        <span class="font-weight-bold text-capitalize">{{ handlerKey(name) }}</span> <br />
        <div v-if="form.country && name == 'country'" class="text-gray-700">
          <span class="text-capitalize">{{ value.label }}</span>
          <span class="text-capitalize" v-if="shouldShowDetailCountry(value.label, value.detailCountry)"> - {{ value.detailCountry }}</span>
        </div>
        <span v-else class="text-gray-700">{{ value }}</span>
      </li>
    </ul>
    <ul v-else class="d-flex justify-content-between flex-wrap">
      <li class="w-50">
        {{ $t('manageplan.component.card.billing-information.final-consumer') }}
      </li>
    </ul>
  </CCardBody>
</template>

<script>
import { getItem } from '@/utils/StorageManager'
import countries from '@/countriesList'

export default {
  name: 'CardBillingInfo',
  data() {
    return {
      organizationId: null,
      hasBilling: false,
      form: {
        country: null,
        tax_Identification_Number: '',
        social_Designation: '',
        address: '',
        postal_Code: '',
        city: '',
      },
      billingData: undefined,
    }
  },

  mounted() {
    // this.optionsCountriesNames = nameCountries(this)

    // this.optionsCountriesNames.push(
    //   {
    //     flag: '/img/flags/pt.svg',
    //     label: this.$t(`general.components.selects.countries.Portugal_Acores`),
    //     value: 'PT',
    //     vies: false,
    //   },
    //   {
    //     flag: '/img/flags/pt.svg',
    //     label: this.$t(`general.components.selects.countries.Portugal_Madeira`),
    //     value: 'PT',
    //     vies: false,
    //   },
    // )

    // this.optionsCountriesNames = this.optionsCountriesNames.sort((countryA, countryB) => {
    //   if (countryA.label < countryB.label) {
    //     return -1
    //   }
    //   if (countryA.label > countryB.label) {
    //     return 1
    //   }
    //   return 0
    // })

    this.organizationId = this.$route.params.organizationId
    this.getBillingInfoState()
  },

  methods: {
    shouldShowDetailCountry(countryName, detailCountry) {
      const isDetailCountryDiffFromName = detailCountry?.toLowerCase() !== countryName.toLowerCase()
      // Não permite que códigos de países sejam exibidos (PT, BR, etc)
      return isDetailCountryDiffFromName && detailCountry?.length > 2
    },

    handlerKey(key) {
      return key.includes('_') ? key.replaceAll('_', ' ') : key
    },

    getBillingInfoState() {
      this.loading = true
      this.billingData = JSON.parse(getItem('stateStep')).billingInfo

      this.hasBilling = this.billingData.isBillingDataRequested || false

      if (this.billingData) {
        if (this.hasBilling) {
          this.form.social_Designation = this.billingData.companyName || ''
          this.form.tax_Identification_Number = this.billingData.taxIdentificationNumber || ''
          this.form.address = this.billingData.streetAddress || ''
          this.form.postal_Code = this.billingData.postalCode || ''
          this.form.city = this.billingData.city || ''
          this.form.country = this.getObjectCountry(this.billingData.countryId) || ''
        }

        this.loading = false

        return true
      }

      return false
    },

    getObjectCountry(countrySelected) {
      const country = countries.filter((country) => country.code.toLowerCase() == countrySelected.toLowerCase())[0]
      return {
        flag: country.flag,
        label: this.$t(`general.components.selects.countries.${country.name}`),
        value: country.code,
        vies: country.vies,
        detailCountry: this.billingData?.detailCountry,
      }
    },
  },
}
</script>

<style lang="scss">
.selectCountry {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  .v-select .vs__dropdown-toggle {
    border-radius: 0;
    border: none;
    height: 50px;
    padding: 0 15px;
  }
}
</style>
